const initLoadMore = () => {
    const loadMoreBtn = document.querySelector('.js-load-more-posts');
    const postsContainer = document.querySelector('.o-grid--blog');
    
    if (!loadMoreBtn || !postsContainer) {
        return;
    }

    // Check if AJAX object is available
    if (typeof loadMorePostsAjax === 'undefined') {
        console.warn('Load More: AJAX object not available');
        return;
    }

    let currentPage = 1;
    let maxPages = parseInt(loadMoreBtn.dataset.maxPages) || 1;
    let isLoading = false;

    // Function to reset pagination (called when filters change)
    const resetPagination = (newMaxPages) => {
        currentPage = 1;
        maxPages = newMaxPages || 1;
        if (loadMoreBtn) {
            loadMoreBtn.dataset.maxPages = maxPages;
        }
    };

    // Expose reset function to window for use by filter script
    if (typeof window !== 'undefined') {
        window.resetLoadMorePagination = resetPagination;
    }

    loadMoreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (isLoading || currentPage >= maxPages) {
            return;
        }

        isLoading = true;
        loadMoreBtn.classList.add('is-loading');
        loadMoreBtn.disabled = true;

        // Get current query parameters from filters
        const categoryId = document.getElementById('category-filter')?.value || '';
        const searchInput = document.querySelector('.globalHeaderBack.blogs #search');
        const searchQuery = searchInput?.value.trim() || '';
        const sortType = document.querySelector('.filter-link.active')?.dataset.sort || 'newest';

        // Make AJAX request
        fetch(loadMorePostsAjax.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'load_more_posts',
                page: currentPage + 1,
                category: categoryId,
                search: searchQuery,
                sort: sortType,
                nonce: loadMorePostsAjax.nonce
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success && data.data.html) {
                // Create a temporary container to parse HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data.data.html;
                
                // Get all article elements (they might be wrapped or direct)
                const newPosts = tempDiv.querySelectorAll('.c-article');
                
                if (newPosts.length === 0) {
                    // If no posts found, hide button
                    loadMoreBtn.style.display = 'none';
                    return;
                }
                
                // Append new posts to container
                newPosts.forEach(post => {
                    postsContainer.appendChild(post);
                });

                currentPage++;
                
                // Hide button if no more pages
                if (currentPage >= maxPages || !data.data.has_more) {
                    loadMoreBtn.style.display = 'none';
                }
            } else {
                console.error('Error loading more posts:', data.data?.message || 'Unknown error');
                loadMoreBtn.style.display = 'none';
            }
        })
        .catch(error => {
            console.error('AJAX error:', error);
            loadMoreBtn.style.display = 'none';
        })
        .finally(() => {
            isLoading = false;
            loadMoreBtn.classList.remove('is-loading');
            loadMoreBtn.disabled = false;
        });
    });
}

export { initLoadMore };

